import React from 'react';
import styled from 'styled-components';
import { Info } from 'etiquette';

const InfoArea = styled.div`
  margin-bottom: 30px;
`;

const PreviewTitle = ({children}) => (
  <InfoArea>
    <Info>{children}</Info>
  </InfoArea>
);

export default PreviewTitle;